import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import { Subtitle } from 'src/front/components/FormStyles';
import { BREAK_POINTS } from 'src/front/constant';
import styled from 'styled-components';

const InfoRow = styled.div`
  display: flex;
  margin-bottom: 20px;
  align-items: center;

  &:last-child {
    margin-bottom: 40px;
  }
`;

const Title = styled(Subtitle)`
  margin: 15px 0;
`;

const LabelItem = styled.span`
  width: 200px;
  margin-right: 22px;

  font-size: 14px;
  ${({ theme }) => `font-family: ${theme.fonts.GothamBold};`}
`;

const InfoItem = styled(LabelItem)`
  width: 300px;
`;

const Border = styled.div`
  width: 160px;
  align-items: center;

  margin-right: 30px;

  border-top: 1px solid ${({ theme }) => theme.palette.smokeGray};
`;

const EndingLine = styled.div`
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.palette.smokeGray};

  margin-bottom: 15px;
`;

const Wrapper = styled.div`
  width: auto;

  @media screen and (max-width: ${BREAK_POINTS.MAX.TABLET}) {
    width: 545px;
  }
`;

interface Props {
  items: Array<{
    title?: string;
    information: Array<{
      label: string;
      info?: string;
    }>;
    hasEndingLine?: boolean;
  }>;
}

const InformationTable: FC<Props> = ({ items }) => {
  return (
    <>
      {items.map((block) => (
        <Wrapper>
          {block.title ? (
            <Title>
              <Trans i18nKey={block.title} />
            </Title>
          ) : null}
          {block.information.map((item) =>
            item.info ? (
              <InfoRow key={item.label}>
                <LabelItem>
                  <Trans i18nKey={item.label} />
                </LabelItem>
                <Border />
                <InfoItem>{item.info}</InfoItem>
              </InfoRow>
            ) : null
          )}
          {block.hasEndingLine ? <EndingLine /> : null}
        </Wrapper>
      ))}
    </>
  );
};

export default InformationTable;
